export const CONF_LOADING = "CONF_LOADING";
export const CONF_SET_EMPRESA = "CONF_SET_EMPRESA";
export const CONF_SET_CONFIGURACOES = "CONF_SET_CONFIGURACOES";
